import { Grid } from '@mui/material';
import { UpdateComponent } from './Update';

export interface Update {
  videoUrl: string;
  fileUrl: string;
  fileName: string;
  videoName: string;
}

export const StartupUpdate = ({ updates }: { updates: Update[] }) => {
  return (
    <Grid container>
      {updates.map((update) => (
        <Grid item key={update.videoUrl} xs={12} md={4}>
          <UpdateComponent update={update} />
        </Grid>
      ))}
    </Grid>
  );
};
